import { IActivityHistoryCustomFilterGroup } from "../../model";

export class AddCustomFiltersCommand {
  constructor(public payload: IActivityHistoryCustomFilterGroup) {}
}
